// extracted by mini-css-extract-plugin
module.exports = {"containerBankInfo":"styles_containerBankInfo__CVLiE"};